import AdsContainer from "@components/Blocks/Container/AdsContainer";
import { TopicsData } from "@components/Blocks/FollowTrendingTopics/FollowTrendingTopics";
import MyBHLayoutOne from "@components/Layouts/MyBHStoryPackages/MyBHLayoutOne";
import MyBHLayoutTwo from "@components/Layouts/MyBHStoryPackages/MyBHLayoutTwo";
import MyBHStartingLayout from "@components/Layouts/MyBHStoryPackages/MyBHStartingLayout";
import { AdsLb2 } from "@elements/Advertisement/variant/AdsLb";
import { ProcessedArticleData } from "@hooks/transformer/useOSResponse";
import { useBHCustomEventAnalyticsCall } from "@hooks/useAnalyticsCall/useBHCustomEventAnalyticsCall";
import { LightboxHandle } from "@hooks/useMySPHLightbox";
import { PageAdTargetValue } from "@typings/Ads";
import { twMerge } from "tailwind-merge";

export type RenderRecommendedProps = {
  activeTab: "untukmu" | "pilihanku";
  startingLayoutArticles: ProcessedArticleData[];
  layoutOneArticles: ProcessedArticleData[];
  layoutTwoArticles: ProcessedArticleData[];
  trendingTopics: TopicsData[];
  adsSectionName: string;
  pageAdTarget: PageAdTargetValue;
  toggleTopic: (topicId: string, topicTitle: string) => Promise<void>;
  shuffleTopics: () => Promise<void>;
  isLoggedIn: boolean;
  followedIds: string[];
  selectedIds: string[];
  lightbox: LightboxHandle | null;
  loadingTopicId: string | null;
  bhCustomEvent?: ReturnType<typeof useBHCustomEventAnalyticsCall>;
  userKeywords?: string;
};

export default function RenderRecommended({
  activeTab,
  startingLayoutArticles,
  layoutOneArticles,
  layoutTwoArticles,
  trendingTopics,
  adsSectionName,
  pageAdTarget,
  isLoggedIn,
  toggleTopic,
  shuffleTopics,
  followedIds,
  selectedIds,
  lightbox,
  loadingTopicId,
  bhCustomEvent,
  userKeywords,
}: RenderRecommendedProps) {
  const isVisible = activeTab === "untukmu";

  return (
    <div
      data-testid="untukmu-container"
      className={twMerge(
        "flex-col w-full gap-8 md:gap-6",
        isVisible ? "flex" : "hidden",
      )}
    >
      <MyBHStartingLayout articles={startingLayoutArticles} />
      <AdsContainer>
        <AdsLb2
          wrapperStyle="mb-0"
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTarget}
          hasStripeBg={false}
        />
      </AdsContainer>
      <MyBHLayoutOne
        key="recommended"
        articles={layoutOneArticles}
        topicsData={trendingTopics}
        onFollow={toggleTopic}
        onUnfollow={toggleTopic}
        onShuffle={shuffleTopics}
        selected={selectedIds}
        unSelect={toggleTopic}
        loadingTopicId={loadingTopicId}
        isLoggedIn={isLoggedIn}
        followedIds={followedIds}
        selectedIds={selectedIds}
        lightbox={lightbox}
        variant="widget"
        bhCustomEvent={bhCustomEvent}
        userKeywords={userKeywords}
      />
      <AdsContainer>
        <AdsLb2
          wrapperStyle="mb-0"
          uniqueSectionName={adsSectionName}
          pageAdTargetType={pageAdTarget}
          hasStripeBg={false}
          index={1}
        />
      </AdsContainer>
      <MyBHLayoutTwo articles={layoutTwoArticles} />
    </div>
  );
}
